import App from 'components/App';
import 'styles/Base.scss';
import '@doda/io-react/pc/index.css';

export default App;
